import './WhyNorthCortex.css'

const differentiators = [
  {
    number: '01',
    icon: <BuildsIcon />,
    title: 'We Build, Not Just Advise',
    body: 'Our value isn\'t in the deck we leave behind. It\'s in the software that runs in your environment. Every engagement ends with working code — reviewed, documented, and handed over with your team knowing how to own it.',
  },
  {
    number: '02',
    icon: <NorthernIcon />,
    title: 'Northern and Present',
    body: 'We\'re based in Huddersfield, available across Leeds and Manchester, and we don\'t parachute in from London. Proximity matters for complex technical work — we can be on-site when it counts.',
  },
  {
    number: '03',
    icon: <ExpertiseIcon />,
    title: 'Senior Expertise Throughout',
    body: 'You get a Principal-level consultant on every engagement — not a graduate sub-contracted after the sales call. Thirty years of software engineering depth, applied directly to your problems.',
  },
]

export default function WhyNorthCortex() {
  return (
    <section className="why section section--grey" id="why">
      <div className="container">
        <div className="why__header">
          <span className="section-eyebrow">Why NorthCortex</span>
          <h2 className="section-heading">
            Real expertise. Real delivery.
          </h2>
          <p className="section-subtext" style={{ marginTop: '0.75rem' }}>
            There are plenty of consultancies happy to take your money for a strategy engagement.
            We measure success differently.
          </p>
        </div>

        <div className="why__grid">
          {differentiators.map((d, i) => (
            <article className="why__card" key={i}>
              <div className="why__card-top">
                <div className="why__card-icon">{d.icon}</div>
                <span className="why__card-number">{d.number}</span>
              </div>
              <h3 className="why__card-title">{d.title}</h3>
              <p className="why__card-body">{d.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}

function BuildsIcon() {
  return (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="16 18 22 12 16 6"/>
      <polyline points="8 6 2 12 8 18"/>
    </svg>
  )
}

function NorthernIcon() {
  return (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
      <polyline points="9 22 9 12 15 12 15 22"/>
    </svg>
  )
}

function ExpertiseIcon() {
  return (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="8" r="4"/>
      <path d="M20 21a8 8 0 1 0-16 0"/>
      <path d="M12 12v4"/>
      <path d="M10 15.5l2 2 2-2"/>
    </svg>
  )
}
